{
    "EmailRule_Failed": "E-mail moet geldig zijn",
    "NAME": "GenericRuleLanguage"
}